import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
import { CTA } from './ui/Button';
export function HeroSection() {
  return <section className="relative pt-8 pb-10 overflow-hidden" data-id="element-85">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-5xl h-[500px] bg-pink-200/40 blur-[100px] rounded-full pointer-events-none" data-id="element-86" />

      <div className="container mx-auto px-4 relative z-10" data-id="element-87">
        <div className="max-w-4xl mx-auto text-center mb-8" data-id="element-88">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-89">
            <p className="text-xs sm:text-sm text-slate-500 font-medium mb-4 tracking-wide max-w-xl mx-auto" data-id="element-90">
              Herramientas para estudiantes de psicope o recibidos que quieran
              iniciar en clínica
            </p>

            <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl font-bold leading-[1.1] tracking-tight mb-6 uppercase text-[#DB2778]" data-id="element-91">
              Inicio en la
              <br data-id="element-92" />
              <span className="text-pink-600" data-id="element-93">Psicopedagogía Clínica</span>
            </h1>

            <p className="text-lg sm:text-xl text-slate-700 font-semibold max-w-2xl mx-auto" data-id="element-94">
              Todo lo que necesitás saber en tus primeros pasos.
            </p>
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="relative max-w-md mx-auto mb-8" data-id="element-95">
          <img src="https://cdn.magicpatterns.com/uploads/uwETBrcdkfcDcGSbdnS3Lg/principal.png" alt="Inicio en la Psicopedagogía Clínica — Aula Mater" className="w-full h-auto drop-shadow-2xl" data-id="element-96" />
        </motion.div>

        <div className="max-w-3xl mx-auto text-center mb-10" data-id="element-97">
          <p className="text-base sm:text-lg text-slate-600 mb-6" data-id="element-98">
            Todo el material organizado para ayudarte a sentirte más segura en{' '}
            <span className="font-semibold text-navy-900" data-id="element-99">
              entrevistas, evaluaciones, intervenciones e informes.
            </span>
          </p>

          <div className="bg-white/70 backdrop-blur-sm border border-slate-100 rounded-2xl p-5 mb-6 shadow-sm" data-id="element-100">
            <p className="font-bold text-navy-900 mb-4 text-sm tracking-widest uppercase" data-id="element-101">
              👉 Acceso inmediato y organizado
            </p>
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 text-sm" data-id="element-102">
              {['Comprás ahora', 'Recibís acceso automático', 'Entrás al material completo', 'Descargás y usás cuando quieras'].map((t, i) => <div key={i} className="flex items-start gap-2" data-id="element-103">
                  <CheckCircle2 className="w-4 h-4 text-green-500 shrink-0 mt-0.5" data-id="element-104" />
                  <span className="text-slate-700 font-medium text-left" data-id="element-105">
                    {t}
                  </span>
                </div>)}
            </div>
          </div>

          <CTA scrollTo="oferta" label="QUIERO EMPEZAR CON MÁS SEGURIDAD" data-id="element-106" />
        </div>
      </div>
    </section>;
}